import {
  defaultAvailabilityConfig,
  type HotelsConfig,
} from "@b2bportal/core-hotels";
import { LodgingSortOrder } from "@b2bportal/lodging-api";

export const hotelAppConfig: HotelsConfig = {
  enableRoomSelection: true,
  enableMealPlans: true,
  availability: defaultAvailabilityConfig,
  enableHomes: true,
  homesDistributionChannels: [{ channelId: "hts" }],
  filterUnavailableLodgings: true,
  availabilitySortOrder: LodgingSortOrder.RbcPreferredChains,
  enableStayTypeFilter: true,
};
